


































































import * as memberAPI from '@adobe/edex/frontend/api/member';
import { paginateMixin } from '@adobe/edex/frontend/mixins/paginate';

enum FollowType {
  followers = 'followers',
  following = 'following',
}

export default {
  props: ['profile'],
  components: {},
  mixins: [paginateMixin],
  data() {
    return {
      loading: false,
      followType: FollowType.following,
      [FollowType.followers]: null,
      [FollowType.following]: null,
    };
  },
  computed: {
    activeTab() {
      return this.tabs.find(({ type }) => type === this.followType);
    },
    tabs() {
      return [
        {
          type: FollowType.following,
          label: 'i18n.member.Following',
          total: this.following.meta.totalRecords,
          data: this.following.data,
          active: this.followType === FollowType.following,
          placeholder: 'i18n.profile.following.label',
        },
        {
          type: FollowType.followers,
          label: 'i18n.member.Followers',
          total: this.followers.meta.totalRecords,
          data: this.followers.data,
          active: this.followType === FollowType.followers,
          placeholder: 'i18n.profile.follower.label',
        },
      ];
    },
    showMore() {
      return this.activeTab.total > this.activeTab.data.length;
    },
  },
  created() {
    this.list(FollowType.followers);
    this.list(FollowType.following);
  },
  methods: {
    async list(type = this.followType) {
      this.loading = true;
      const apiFunction =
        type === FollowType.following
          ? memberAPI.listFollowing
          : memberAPI.listFollowers;
      const api = config => apiFunction(this.profile.id, config);
      await this.paginate({
        api,
        name: type,
        params: { limit: 8 },
      });
      this.loading = false;
    },
    onMore() {
      this.list();
    },
  },
};
